module.exports = __webpack_public_path__ + "img/pick3.fbca339c.png";